import type { Lottery } from '@lotta/shared/types-lottery-schemas';

/**
 * Get lottery signup type matching ikea domain signup
 * type param
 */
export const getLotterySignupType = (lottery: Lottery): string | undefined => {
  if (lottery.modules.includes('swipe')) {
    return 'swipe';
  } else if (lottery.modules.includes('simple-signup')) {
    return 'simple';
  } else {
    return undefined;
  }
};
